<template>
    <v-container class="content" >
      <LoginLogo />

      <v-row no-gutters justify="center" align="center" class="text-center mb-5">
        {{$t('routes.expired.yourAccountHasExpired')}}
      </v-row>

      <v-row no-gutters justify="center" align="center" class="">
        <v-btn type="button" v-on:click="logOut" class="bg-primary">
          <!-- <v-icon>mdi-arrow-left</v-icon> -->
          {{$t('routes.expired.logout')}}
        </v-btn>
      </v-row>
    </v-container>
</template>

<script>
import LoginLogo from '../account/components/LoginLogo.vue'

export default {
  name: "ExpiredPage",
  components: {
    LoginLogo,
  },
  methods: {
    logOut: function() {
      this.$router.push('/account/logout');
    }
  }
}
</script>
